/* friky-i18n.js — idioma de NUESTRAS apps (buscador, Silvia, chat, club, reseñas,
   deseos, +18, B2B, geo). Los textos viven en español en el código y aquí se
   traducen al idioma del mercado que se está sirviendo.
   Uso: FT('texto en español') → devuelve el texto en el idioma activo.
   Si el idioma o el texto no están en el diccionario, devuelve el original: nunca rompe. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var DIC = {
    'pt-pt': {
      /* ── Escalera del envío (carrito y ficha) ── */
      "Gastos de envío": "Portes de envio",
      "Ahora pagas": "Agora pagas",
      "¡Envío gratis!": "Envio grátis!",
      "hasta 30 €": "até 30 €",
      "más de 70 €": "mais de 70 €",
      "GRATIS": "GRÁTIS",
      "Añade": "Adiciona",
      "y <b>el envío es gratis</b>.": "e <b>o envio é grátis</b>.",
      "y el envío baja a": "e o envio desce a",
      "Tienes <b>envío gratis</b>. Bien jugado.": "Tens <b>envio grátis</b>. Bem jogado.",
      "Con este artículo en la cesta": "Com este artigo no cesto",
      /* ── Chat / Silvia: avisos e formulario de factura ── */
      "¡Genial! 🛍️ Soy tu personal shopper friki. Cuéntame para quién es o qué buscas": "Boa! 🛍️ Sou a tua personal shopper friki. Diz-me para quem é ou o que procuras",
      "La imagen es muy grande (máx 10 MB) 🙏": "A imagem é demasiado grande (máx. 10 MB) 🙏",
      "No se pudo generar la factura.": "Não foi possível gerar a fatura.",
      "Te paso con una persona del equipo": "Passo-te a uma pessoa da equipa",
      "Fuera de horario: un compañero te responderá en cuanto abramos (L-V 9-18h). Puedes dejar tu email y te avisamos.": "Fora de horário: um colega responde-te assim que abrirmos (2ª a 6ª, 9-18h). Podes deixar o teu email e avisamos-te.",
      "¿Quieres que te avisemos por email cuando te respondamos? Si prefieres que no, no pasa nada: al volver al chat seguirás aquí con toda la conversación.": "Queres que te avisemos por email quando respondermos? Se preferires que não, tudo bem: ao voltares ao chat continuas aqui com toda a conversa.",
      "🧾 Datos para tu factura": "🧾 Dados para a tua fatura",
      "NIF / DNI": "NIF",
      "Nombre o razón social": "Nome ou denominação social",
      /* ── Chat de Silvia: avisos, escalado y formulario de factura ── */
      "¡Ey, bienvenid@ a Frikytopia! 👾 Soy **Alex**, tu compi friki. Antes de lanzarnos, dime tu **nombre y apellido** para tratarte como mereces… y al lío 🚀": "Olá, bem-vind@ à Frikytopia! 👾 Sou o **João**, o teu colega friki. Antes de começarmos, diz-me o teu **nome e apelido** para te tratar como mereces… e vamos a isso 🚀",
      "¡Lista! 🎉 Aquí tienes tu factura **": "Pronto! 🎉 Aqui tens a tua fatura **",
      "Te paso con una persona del equipo 👤 (en unos minutos).": "Passo-te a uma pessoa da equipa 👤 (dentro de minutos).",
      "Rellena pedido, email y NIF, porfa 🙏": "Preenche encomenda, email e NIF, por favor 🙏",
      "Ups, ha fallado. Inténtalo de nuevo.": "Ups, falhou. Tenta novamente.",
      "📧 Avísame por email": "📧 Avisa-me por email",
      "💬 Seguir solo por el chat": "💬 Continuar só pelo chat",
      "No he podido enviar la imagen, inténtalo de nuevo 🙏": "Não consegui enviar a imagem, tenta novamente 🙏",
      " Soy recargo de equivalencia": " Estou em regime de equivalência",
      /* ── Club Friky: página, panel lateral, saldo y pop-up ── */
      "Parece que nos visitas desde ": "Parece que nos visitas de ",
      "\">Ir a ": "\">Ir para ",
      "España": "Espanha",
      "Quiero mi figura": "Quero a minha figura",
      "Regalo de bienvenida": "Presente de boas-vindas",
      " puntos de regalo al registrarte": " pontos de presente ao registares-te",
      "<p class=\"fpc-sub\">Son ": "<p class=\"fpc-sub\">São ",
      ">Quiero mis ": ">Quero os meus ",
      " puntos</a>": " pontos</a>",
      "aria-label=\"Cerrar\"": "aria-label=\"Fechar\"",
      " para tu próxima compra. Los canjeas cuando quieras y por el importe que quieras, sin mínimos.": " para a tua próxima compra. Trocas quando quiseres e pelo valor que quiseres, sem mínimos.",
      "Solo por registrarte entras en el sorteo mensual de una figura de coleccionista. Y empiezas a sumar puntos desde tu primera compra.": "Só por te registares entras no sorteio mensal de uma figura de colecionador. E começas a somar pontos desde a primeira compra.",
      "Reintentar canje": "Tentar a troca de novo",
      "Empieza a sumar puntos con cada compra y acción.": "Começa a somar pontos em cada compra e ação.",
      "Ver mis puntos": "Ver os meus pontos",
      "¿Aún no eres del club?": "Ainda não és do clube?",
      "Es gratis: crea tu cuenta y llévate": "É grátis: cria a tua conta e leva",
      "de bienvenida.": "de boas-vindas.",
      "Únete gratis": "Junta-te grátis",
      "Ya soy socio": "Já sou sócio",
      "Cómo ganar puntos": "Como ganhar pontos",
      "Cada acción suma. Cuantos más puntos acumules, mayores serán tus descuentos y tu nivel.": "Cada ação conta. Quantos mais pontos juntares, maiores serão os teus descontos e o teu nível.",
      "Comprar en la tienda": "Comprar na loja",
      "1 punto por cada 1&nbsp;€": "1 ponto por cada 1&nbsp;€",
      "¡y multiplicado según tu nivel!": "e multiplicado conforme o teu nível!",
      "Cómo canjear tus puntos": "Como trocar os teus pontos",
      "100 puntos =": "100 pontos =",
      "5&nbsp;€ de descuento": "5&nbsp;€ de desconto",
      ". Canjéalos desde tu cuenta y recibe un código para aplicar en tu próxima compra.": ". Troca-os na tua conta e recebe um código para usar na tua próxima compra.",
      "Acumula puntos con tus compras y acciones.": "Junta pontos com as tuas compras e ações.",
      "y elige cuántos canjear.": "e escolhe quantos queres trocar.",
      "Recibes un código de descuento y lo aplicas en el carrito.": "Recebes um código de desconto e aplica-lo no carrinho.",
      "Los niveles del club": "Os níveis do clube",
      "Cuanto más activo eres, más subes de rango. Cada nivel multiplica tus puntos y desbloquea ventajas.": "Quanto mais ativo és, mais sobes de patente. Cada nível multiplica os teus pontos e desbloqueia vantagens.",
      "Recluta": "Recruta",
      "x1 puntos": "x1 pontos",
      "Ganas puntos con cada compra": "Ganhas pontos em cada compra",
      "Usa tus puntos como descuento": "Usa os teus pontos como desconto",
      "Ofertas de bienvenida": "Promoções de boas-vindas",
      "x1,2 puntos en cada compra": "x1,2 pontos em cada compra",
      "x1,2 puntos": "x1,2 pontos",
      "Ofertas exclusivas del club": "Promoções exclusivas do clube",
      "Wishlist con avisos": "Lista de desejos com avisos",
      "x1,5 puntos": "x1,5 pontos",
      "Envío gratis desde 30&nbsp;€": "Envio grátis a partir de 30&nbsp;€",
      "Acceso 24&nbsp;h antes a drops": "Acesso 24&nbsp;h antes aos drops",
      "Soporte prioritario": "Apoio prioritário",
      "Leyenda": "Lenda",
      "x2 puntos en cada compra": "x2 pontos em cada compra",
      "x2 puntos": "x2 pontos",
      "Envío gratis siempre": "Envio grátis sempre",
      "Acceso 48&nbsp;h antes a drops y preventas": "Acesso 48&nbsp;h antes a drops e pré-vendas",
      "Regalo sorpresa trimestral": "Presente surpresa trimestral",
      "Atención VIP con Alex": "Atendimento VIP com Alex",
      "Tu nivel se calcula según tu actividad dentro del club, así que siempre puedes seguir subiendo.": "O teu nível é calculado pela tua atividade dentro do clube, por isso podes continuar sempre a subir.",
      "Trae a un amigo y ganáis los dos": "Traz um amigo e ganham os dois",
      "Comparte Frikytopia con otro friki. Cuando haga su primera compra, tú te llevas": "Partilha a Frikytopia com outro friki. Quando ele fizer a primeira compra, levas",
      "(12,50&nbsp;€). Encuentra tu enlace de invitación en tu cuenta.": "(12,50&nbsp;€). Encontra o teu link de convite na tua conta.",
      "Ver mi enlace de invitación": "Ver o meu link de convite",
      "Únete y consigue tu enlace": "Junta-te e recebe o teu link",
      "250 puntos": "250 pontos",
      "100 puntos": "100 pontos",
      "tu cuenta": "a tua conta",
      "Entra en": "Entra em",
      "Nivel": "Nível",
      "Hazte del club y llévate una figura gratis": "Junta-te ao clube e leva uma figura grátis",
      "Envío gratis en tu primer pedido": "Envio grátis na tua primeira encomenda",
      "Date de alta y te lo llevas sin gastos de envío. Además entras en el club y empiezas a acumular puntos.": "Regista-te e recebes a encomenda sem portes. Além disso entras no clube e começas a somar pontos.",
      "Quiero el envío gratis": "Quero o envio grátis",
      "Solo para socios": "Só para sócios",
      "Ahora no": "Agora não",
      "En otro momento": "Noutra altura",
      "Tu saldo del Club": "O teu saldo do Clube",
      "Todavía no tienes vales.": "Ainda não tens vales.",
      "Sin vales todavía": "Sem vales ainda",
      "Generando tu vale…": "A gerar o teu vale…",
      "Generando…": "A gerar…",
      "No se ha podido, reintentar": "Não foi possível, tentar de novo",
      "¡Copiado! ✓": "Copiado! ✓",
      "Copiar código": "Copiar código",
      "Tu código": "O teu código",
      "Convertir en vale": "Converter em vale",
      "También lo tienes guardado en tu Club, por si prefieres gastarlo otro día.": "Também fica guardado no teu Clube, caso prefiras usá-lo noutro dia.",
      "puntos sin canjear. No caducan.": "pontos por trocar. Não caducam.",
      "Tu vale de": "O teu vale de",
      "está listo": "está pronto",
      "en el Club": "no Clube",
      "Cargando tu club…": "A carregar o teu clube…",
      "Ya soy socio · Iniciar sesión": "Já sou sócio · Iniciar sessão",
      "Suma puntos con cada compra, sube de nivel y desbloquea ventajas y logros exclusivos. ¡Únete gratis!": "Soma pontos em cada compra, sobe de nível e desbloqueia vantagens e conquistas exclusivas. Junta-te grátis!",
      "🏆 Niveles del club": "🏆 Níveis do clube",
      "Tu vale de descuento": "O teu vale de desconto",
      "Válido en compras desde": "Válido em compras a partir de",
      "· aplícalo en el pago": "· aplica-o no pagamento",
      "Cupon del club": "Cupão do clube",
      "Convertir puntos": "Converter pontos",
      "Copiar": "Copiar",
      "Gratis": "Grátis",
      "Tienes": "Tens",
      "<h2>Contenido para mayores de edad</h2>": "<h2>Conteúdo para maiores de idade</h2>",
      "<p>Este contenido es para mayores de edad. ¿Confirmas que tienes <b>18 años o más</b>?</p>": "<p>Este conteúdo é para maiores de idade. Confirmas que tens <b>18 anos ou mais</b>?</p>",
      "<button class=\"age18-no\" type=\"button\">No, salir</button>": "<button class=\"age18-no\" type=\"button\">Não, sair</button>",
      "<div class=\"age18-legal\">Al confirmar declaras ser mayor de edad. Guardamos tu elección en este dispositivo.</div>": "<div class=\"age18-legal\">Ao confirmar, declaras ser maior de idade. Guardamos a tua escolha neste dispositivo.</div>",
      "Tu pedido profesional": "O teu pedido profissional",
      "Finalizar pedido profesional": "Finalizar compra profissional",
      "Creando tu pedido…": "A criar o teu pedido…",
      "Preparando tu pago…": "A preparar o teu pagamento…",
      "No se pudo crear el pedido profesional": "Não foi possível criar o pedido profissional",
      "Error al crear el pedido.": "Erro ao criar o pedido.",
      "<div class=\"fb2bc-sum re\"><span>Recargo de equivalencia ": "<div class=\"fb2bc-sum re\"><span>Imposto de equivalência ",
      "<div class=\"fb2bc-h\">🛒 Tu pedido profesional <span class=\"fb2bc-tag\">PRECIOS B2B</span></div>": "<div class=\"fb2bc-h\">🛒 O teu pedido profissional <span class=\"fb2bc-tag\">PREÇOS B2B</span></div>",
      "<button type=\"button\" class=\"fb2bc-btn fb2bc-go\">Finalizar pedido profesional →</button>": "<button type=\"button\" class=\"fb2bc-btn fb2bc-go\">Finalizar compra profissional →</button>",
      "el globo": "o balão",
      "Más de 100€": "Mais de 100€",
      "añadir al carrito": "adicionar ao carrinho",
      "<span class=\"fkb-sv-itx\"><b>Alex:</b> ¿exploras tú por todo el universo… o te ayudo a encontrar la Fuerza? ✨</span>": "<span class=\"fkb-sv-itx\"><b>Alex:</b> Explores tu o universo… ou ajudo-te a encontrar a Força? ✨</span>",
      "\" aria-label=\"Añadir\"><span class=\"fkb-add-ic\">🛒</span></button>": "\" aria-label=\"Adicionar\"><span class=\"fkb-add-ic\">🛒</span></button>",
      "<span class=\"fkb-sv-favbadge\">⭐ Favorita de Alex</span>": "<span class=\"fkb-sv-favbadge\">⭐ Favorita de Alex</span>",
      "<input type=\"text\" class=\"fkb-sv-free\" placeholder=\"✏️ Escribe lo que buscas (Naruto, Stitch, Stranger Things…)\">": "<input type=\"text\" class=\"fkb-sv-free\" placeholder=\"✏️ Escreve o que procuras (Naruto, Stitch, Stranger Things…)\">",
      "<span class=\"fkb-sv-glab\">Qué tipo</span>": "<span class=\"fkb-sv-glab\">Que tipo</span>",
      "<button class=\"fkb-sv-go\" type=\"button\">✨ Buscar mi regalo</button></div>": "<button class=\"fkb-sv-go\" type=\"button\">✨ Pesquisar o meu presente</button></div>",
      "Enséñame lo más vendido": "Mostra-me o mais vendido",
      "Cuéntame qué buscas…": "Diz-me o que procuras…",
      "Escribe a Alex": "Escreve a Alex",
      "Sin tope 🚀": "Sem limite 🚀",
      "¡Hola! Soy <b>Alex</b> 🚀 Toca lo que encaje y te encuentro el regalo perfecto (o escríbeme abajo):": "Olá! Sou <b>Alex</b> 🚀 Escolhe o que se encaixa e encontro-te o presente perfeito (ou escreve-me em baixo):",
      "Ahora mismo no puedo ayudarte con eso 😕. Un compañero del equipo te responde por aquí enseguida 🙏.": "Agora mesmo não consigo ajudar-te com isso 😕. Um colega da equipa responde-te aqui já a seguir 🙏.",
      "🔎 Ver todos los resultados": "🔎 Ver todos os resultados",
      "Ups, no he podido responder 😕. Inténtalo de nuevo en un momento.": "Ups, não consegui responder 😕. Tenta novamente dentro de momentos.",
      "Buscar": "Pesquisar",
      "Borrar búsqueda": "Apagar pesquisa",
      "Hablar con Alex": "Falar com Alex",
      "<span class=\"fkb-ship\">🚚 Envío gratis</span>": "<span class=\"fkb-ship\">🚚 Envio grátis</span>",
      "\" aria-label=\"Añadir al carrito\" title=\"Añadir al carrito\"><span class=\"fkb-add-ic\">🛒</span></button>": "\" aria-label=\"Adicionar ao carrinho\" title=\"Adicionar ao carrinho\"><span class=\"fkb-add-ic\">🛒</span></button>",
      "⭐ Los más vendidos": "⭐ Os mais vendidos",
      "<div class=\"fkb-msg\">No se pudo buscar.</div>": "<div class=\"fkb-msg\">Não foi possível pesquisar.</div>",
      "Solo con stock": "Só com stock",
      "Precio": "Preço",
      "Más vendidos": "Mais vendidos",
      "Precio ↑": "Preço ↑",
      "Precio ↓": "Preço ↓",
      "<div class=\"fkb-msg\">Sin resultados. Prueba con otra palabra o quita filtros.</div>": "<div class=\"fkb-msg\">Sem resultados. Tenta outra palavra ou remove filtros.</div>",
      "🛍️ También te puede interesar": "🛍️ Também pode interessar-te",
      "Añadido con tu producto": "Adicionado com o teu produto",
      "¡Encantada": "Olá",
      "! 😊 ¿Con qué te ayudo?": "! 😊 Em que te posso ajudar?",
      "🎁 Ayuda para comprar o buscar un regalo": "🎁 Ajuda para comprar ou encontrar um presente",
      "💬 Atención al cliente (envíos, devoluciones, pagos…)": "💬 Apoio ao cliente (envios, devoluções, pagamentos…)",
      "📦 ¿Dónde está mi pedido?": "📦 Onde está o meu pedido?",
      "¿Dónde está mi pedido?": "Onde está o meu pedido?",
      "Ayuda para comprar 🎁": "Ajuda para comprar 🎁",
      "Atención al cliente 💬": "Apoio ao cliente 💬",
      "¡Perfecto! Cuando vuelvas al chat lo encontrarás aquí, con toda la conversación 👍": "Perfeito! Quando voltares ao chat encontrá-lo-ás aqui, com toda a conversa 👍",
      "Genial 😊 Déjanos tu email y te avisamos por correo en cuanto te respondamos:": "Ótimo 😊 Deixa-nos o teu email e avisamos-te por correio assim que te respondermos:",
      "¡Perfecto! Te avisaremos a ": "Perfeito! Avisamos-te para ",
      "Fuera de horario (L-V 9-18h)": "Fora de horário (Seg-Sex 9-18h)",
      ">\\uD83E\\uDDFE Datos para tu factura</div>'+invInput(": ">\\uD83E\\uDDFE Dados para a tua fatura</div>'+invInput(",
      "N\\xBA de pedido (ej. 291305)": "N.º de pedido (ex. 291305)",
      "Email del pedido": "Email do pedido",
      "> Soy recargo de equivalencia</label><button id=": "> Sou imposto de equivalência</label><button id=",
      "Un compa\\xF1ero del equipo est\\xE1 atendiendo tu consulta\\u2026": "Um colega da equipa está a tratar da tua questão…",
      "Ups, ha fallado el env\\xEDo. Int\\xE9ntalo de nuevo.": "Ups, falhou o envio. Tenta novamente.",
      "Únete al club": "Junta-te ao clube",
      "Tu cumpleaños": "O teu aniversário",
      "Valora un producto": "Avalia um produto",
      "Reseña con foto/vídeo": "Avaliação com foto/vídeo",
      "Reseña en Google": "Avaliação no Google",
      "Reseña en Trustpilot": "Avaliação no Trustpilot",
      "Añade a favoritos": "Adiciona aos favoritos",
      "Sube tu colección": "Partilha a tua coleção",
      "Síguenos en Instagram": "Segue-nos no Instagram",
      "Síguenos en TikTok": "Segue-nos no TikTok",
      "Síguenos en YouTube": "Segue-nos no YouTube",
      "Síguenos en Facebook": "Segue-nos no Facebook",
      "Síguenos en X": "Segue-nos no X",
      "Comparte un producto": "Partilha um produto",
      "Suscríbete a la newsletter": "Subscreve a newsletter",
      "<div class=\"fkr-reply\"><b>Respuesta de Frikytopia:</b> ": "<div class=\"fkr-reply\"><b>Resposta de Frikytopia:</b> ",
      "<div class=\"fkr-empty\">Sé el primero en opinar sobre este producto.</div>": "<div class=\"fkr-empty\">Sê o primeiro a dar a tua opinião sobre este produto.</div>",
      "<div class=\"fkr-field\"><label>Tu puntuación</label><div class=\"fkr-picker\">": "<div class=\"fkr-field\"><label>A tua pontuação</label><div class=\"fkr-picker\">",
      "<div class=\"fkr-field\"><label>Título</label><input name=\"title\" maxlength=\"140\" placeholder=\"Resume tu opinión\"></div>": "<div class=\"fkr-field\"><label>Título</label><input name=\"title\" maxlength=\"140\" placeholder=\"Resume a tua opinião\"></div>",
      "Elige una puntuación.": "Escolhe uma pontuação.",
      "<div class=\"fkr-thanks\">¡Gracias por tu opinión! ": "<div class=\"fkr-thanks\">Obrigado pela tua opinião! ",
      "Ya está publicada.": "Já está publicada.",
      "La revisaremos y se publicará pronto.": "Vamos revê-la e será publicada em breve.",
      "Enviar reseña": "Enviar avaliação",
      "No se pudo enviar. Inténtalo de nuevo.": "Não foi possível enviar. Tenta novamente.",
      "✅ <b>Añadido al carrito.</b> <a href=\"/cart\">Ver carrito</a>": "✅ <b>Adicionado ao carrinho.</b> <a href=\"/cart\">Ver carrinho</a>",
      "No he podido añadirlo automáticamente 😕. Puedes añadirlo desde <a href=\"": "Não consegui adicioná-lo automaticamente 😕. Podes adicioná-lo a partir de <a href=\"",
      "te faltan X € para envío gratis": "faltam-te X € para envio grátis",
      "Ups, error de conexión. Inténtalo de nuevo en un momento 🙏": "Ups, erro de ligação. Tenta novamente dentro de momentos 🙏",
      "¡Hola! Soy Alex 👋 ¿Buscas un regalo o algo para ti? Cuéntame para quién es o qué te gusta y te ayudo a acertar.": "Olá! Sou Alex 👋 Estás à procura de uma prenda ou de algo para ti? Diz-me para quem é ou o que gostas e ajudo-te a acertar.",
      "Recomiéndame": "Recomenda-me",
      "<span class=\"silvia-home__txt\"><b>¿Buscas un regalo o tienes una duda?</b>": "<span class=\"silvia-home__txt\"><b>Procuras uma prenda ou tens alguma dúvida?</b>",
      "<span class=\"silvia-home__sub\">Habla con Alex, tu personal shopper friki 👋</span></span>": "<span class=\"silvia-home__sub\">Fala com Alex, personal shopper friki 👋</span></span>",
      "¡Hola! Soy Alex 👋 Pregúntame lo que necesites: envíos, devoluciones, seguimiento de pedido, recomendaciones…": "Olá! Sou Alex 👋 Pergunta-me o que precisares: envios, devoluções, seguimento de encomenda, recomendações…",
      "Alex responde con la información de Frikytopia. Si algo no lo sabe, te pone en contacto con atención al cliente.": "Alex responde com informações de Frikytopia. Se não souber algo, coloca-te em contacto com o apoio ao cliente.",
      "¿Cuánto tarda el envío?": "Quanto tempo demora o envio?",
      "¿Cómo hago una devolución?": "Como faço uma devolução?",
      "Seguimiento de mi pedido": "Seguimento da minha encomenda",
      "Métodos de pago": "Métodos de pagamento",
      "Recomiéndame un regalo friki": "Recomenda-me uma prenda friki",
      "Tu experto": "O teu especialista",
      "¿Alguna pregunta sobre este producto?": "Alguma pergunta sobre este produto?",
      "¿Qué quieres saber de este producto?": "O que queres saber sobre este produto?",
      "¿De qué material es?": "De que material é?",
      "¿Qué tamaño tiene?": "Que tamanho tem?",
      "¿Está disponible?": "Está disponível?",
      "¿Es original?": "É original?",
      "¡Añadido a tu lista de deseos! ❤️": "Adicionado à tua lista de desejos! ❤️",
      "No se pudo guardar, inténtalo de nuevo": "Não foi possível guardar, tenta novamente",
      "Guardado en tu lista ❤️ · inicia sesión para conservarla": "Guardado na tua lista ❤️ · inicia sessão para a conservar",
      "Añadir a deseos": "Adicionar aos desejos",
      "** \\uD83D\\uDC47 \\xBFcu\\xE1l es tu duda?": "** \\uD83D\\uDC47 \\xBFQual é a tua dúvida?",
      "Preparando la categor\\xEDa \\xAB": "A preparar a categoria \\xAB",
      "<div style=\"padding:40px;text-align:center;color:#9aa4b2\">No se pudo cargar el club. Reintenta.</div>": "<div style=\"padding:40px;text-align:center;color:#9aa4b2\">Não foi possível carregar o clube. Tenta novamente.</div>",
      "</b> puntos · vale ": "</b> pontos · vale ",
      "<div class=\"fclub-bar__t\">Sigue sumando para llegar a ": "<div class=\"fclub-bar__t\">Continua a acumular para chegar a ",
      "<div class=\"fclub-bar__t\" style=\"margin-top:12px\">🎉 ¡Estás en el nivel máximo!</div>": "<div class=\"fclub-bar__t\" style=\"margin-top:12px\">🎉 Estás no nível máximo!</div>",
      "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🎖️ Tus ventajas</div>": "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🎖️ As tuas vantagens</div>",
      "<span class=\"fclub-lvl__b fclub-lvl__b--you\">TÚ</span>": "<span class=\"fclub-lvl__b fclub-lvl__b--you\">TU</span>",
      "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\"><span>🏅 Tus logros</span><span style=\"color:#f5bb2d\">": "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\"><span>🏅 As tuas conquistas</span><span style=\"color:#f5bb2d\">",
      "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">💰 Canjea tus puntos</div>": "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">💰 Troca os teus pontos</div>",
      " puntos = ": " pontos = ",
      " \\u00b7 canjea el importe que quieras, sin m\\u00ednimos</div>": " \\u00b7 troca o valor que quiseres, sem mínimos</div>",
  "Lo tienes en «Mis vales» y aquí abajo, con su código listo para usar.": "Tens ele em «Os meus vales» e aqui abaixo, com o código pronto a usar.",
  "Los tienes en «Mis vales» y aquí abajo, con su código listo para usar.": "Tens eles em «Os meus vales» e aqui abaixo, com o código pronto a usar.",
  "Puntos no te quedan: volverás a sumar con tu próxima compra.": "Pontos não tens: voltarás a somar com a tua próxima compra.",
      "<div class=\"fclub-bar__t\" style=\"color:#9aa4b2\">Aún no tienes puntos que canjear</div>": "<div class=\"fclub-bar__t\" style=\"color:#9aa4b2\">Ainda não tens pontos para trocar</div>",
      "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🎁 Gana más puntos</div>": "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🎁 Ganha mais pontos</div>",
      "</div><div class=\"fclub-foot\">Club Frikytopia · tu pasión, recompensada</div>": "</div><div class=\"fclub-foot\">Club Frikytopia · a tua paixão, recompensada</div>",
      "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🏆 Los niveles</div><div class=\"fclub-lad\">": "<div class=\"fclub-sec\"><div class=\"fclub-sec__h\">🏆 Os níveis</div><div class=\"fclub-lad\">",
      "<div class=\"fclub-sec\"><a class=\"fclub-cta\" href=\"/account/register\">Únete al club (gratis)</a>": "<div class=\"fclub-sec\"><a class=\"fclub-cta\" href=\"/account/register\">Junta-te ao clube (grátis)</a>",
      "<div class=\"fclub-foot\">Club Frikytopia · tu pasión, recompensada</div>": "<div class=\"fclub-foot\">Club Frikytopia · a tua paixão, recompensada</div>",
      "Añadir al carrito": "Adicionar ao carrinho",
      "🛒 Añadir al carrito": "🛒 Adicionar ao carrinho",
      "Añadiendo…": "A adicionar…",
      "sin variante": "sem variante",
      "✓ Añadido": "✓ Adicionado",
      "✓ Producto añadido al carrito": "✓ Produto adicionado ao carrinho",
      "No se pudo añadir. Abriendo la ficha…": "Não foi possível adicionar. A abrir a ficha…",
      "<div class=\"friky-rate__h\">¿Qué te ha parecido?</div>": "<div class=\"friky-rate__h\">O que achaste?</div>",
      "<div class=\"friky-rate__sub\">Tu opinión nos ayuda a mejorar el contenido</div>": "<div class=\"friky-rate__sub\">A tua opinião ajuda-nos a melhorar o conteúdo</div>",
      "Sé el primero en valorar": "Sê o primeiro a avaliar",
      "✓ ¡Gracias por tu valoración!": "✓ Obrigado pela tua avaliação!",
      "No se pudo registrar el voto": "Não foi possível registar o voto",
      "✓ Guardado en tu lista": "✓ Guardado na tua lista",
      "Quitado de tu lista": "Removido da tua lista",
      "<p class=\"friky-saved__empty\">Aún no has guardado ningún artículo. Pulsa “♡ Guardar” en cualquier artículo del blog.</p>": "<p class=\"friky-saved__empty\">Ainda não guardaste nenhum artigo. Clica em \"♡ Guardar\" em qualquer artigo do blog.</p>",
      "<input class=\"friky-cform__name\" type=\"text\" placeholder=\"Tu nombre\" maxlength=\"60\" required>": "<input class=\"friky-cform__name\" type=\"text\" placeholder=\"O teu nome\" maxlength=\"60\" required>",
      "<textarea class=\"friky-cform__text\" placeholder=\"Escribe un comentario...\" maxlength=\"3000\" required></textarea>": "<textarea class=\"friky-cform__text\" placeholder=\"Escreve um comentário...\" maxlength=\"3000\" required></textarea>",
      "<p class=\"friky-cform__note\">Los comentarios se revisan antes de publicarse.</p>": "<p class=\"friky-cform__note\">Os comentários são revistos antes de serem publicados.</p>",
      "<p class=\"friky-comments__empty\">Sé el primero en comentar.</p>": "<p class=\"friky-comments__empty\">Sê o primeiro a comentar.</p>",
      "No se pudo enviar": "Não foi possível enviar",
      "✓ ¡Gracias! Tu comentario se publicará tras revisión.": "✓ Obrigado! O teu comentário será publicado após revisão.",
      "Error de conexión": "Erro de ligação",
      "<div class=\"friky-bis__h\">😢 Agotado — ¿te avisamos cuando vuelva?</div>": "<div class=\"friky-bis__h\">😢 Esgotado — avisamos-te quando voltar?</div>",
      "<button type=\"submit\">Avísame</button>": "<button type=\"submit\">Avisa-me</button>",
      "avísame": "avisa-me",
      "No se pudo registrar": "Não foi possível registar",
      "Precio de lanzamiento: <s>": "Preço de lançamento: <s>",
      "<span class=\"friky-pricehist__same\">✓ Mismo precio desde su lanzamiento</span>": "<span class=\"friky-pricehist__same\">✓ Mesmo preço desde o lançamento</span>",
      "<p style=\"text-align:center;opacity:.7\">Test no disponible.</p>": "<p style=\"text-align:center;opacity:.7\">Teste não disponível.</p>",
      "<button type=\"button\" class=\"friky-quiz__go\">Ver mi resultado</button>": "<button type=\"button\" class=\"friky-quiz__go\">Ver o meu resultado</button>",
      "Responde todas las preguntas 🙂": "Responde a todas as perguntas 🙂",
      "\">Ver recomendaciones →</a>": "\">Ver recomendações →</a>",
      "<p style=\"text-align:center;opacity:.7\">No se pudo cargar el test.</p>": "<p style=\"text-align:center;opacity:.7\">Não foi possível carregar o teste.</p>",
      "Añadir a la cesta": "Adicionar ao carrinho",
      "Este producto no se puede comprar con el pago rápido. Añádelo a la cesta y finaliza la compra desde la cesta.": "Este produto não pode ser comprado com o pagamento rápido. Adiciona-o ao carrinho e finaliza a compra a partir do carrinho.",
      "Añádelo a la cesta y finaliza la compra desde la cesta.": "Adiciona-o ao carrinho e finaliza a compra a partir do carrinho.",
      "Este producto no se puede comprar con el pago rápido.": "Este produto não pode ser comprado com o pagamento rápido.",
      "Producto añadido a la cesta": "Produto adicionado ao carrinho",
      "añadido a la cesta": "adicionado ao carrinho",
      "<div class=\"friky-feat__head\"><div class=\"friky-feat__t\">✨ No te lo pierdas</div>": "<div class=\"friky-feat__head\"><div class=\"friky-feat__t\">✨ Não percas isto</div>",
      "<div class=\"friky-feat__sub\">Una selección para que descubras cosas nuevas</div></div>": "<div class=\"friky-feat__sub\">Uma seleção para descobrires coisas novas</div></div>",
      "Scroll infinito activado · volver a páginas": "Scroll infinito ativado · voltar às páginas",
      "Ver en scroll infinito": "Ver em scroll infinito",
      "No hay más productos · volver a páginas": "Não há mais produtos · voltar às páginas",
      "<p id=\"friky-geo__p\">Tenemos una tienda para ": "<p id=\"friky-geo__p\">Temos uma loja para ",
      " con tus precios e impuestos correctos y envío local.</p>": " com os teus preços e impostos corretos e envio local.</p>",
      "<button id=\"friky-geo__stay\">Seguir aquí</button>": "<button id=\"friky-geo__stay\">Continuar aqui</button>",
      "<h2 class=\"fkr-title\">Opiniones de clientes</h2><div class=\"fkr-head\">": "<h2 class=\"fkr-title\">Opiniões de clientes</h2><div class=\"fkr-head\">",
      "reseñas": "avaliações",
      "Sin reseñas todavía": "Sem avaliações ainda",
      "<button class=\"fkr-write\" type=\"button\">✍️ Escribir una reseña</button></div>": "<button class=\"fkr-write\" type=\"button\">✍️ Escrever uma avaliação</button></div>",
      "No se pudo guardar, int\\xE9ntalo de nuevo": "Não foi possível guardar, tenta novamente",
      /* ── Complementos de producto (caja protectora) ── */
      "Añadir caja protectora semirrígida": "Adicionar caixa protetora semirrígida",
      "Protege tu Funko con nuestras cajas específicas.": "Protege o teu Funko com as nossas caixas específicas.",
      "Protege tu Funko con nuestras cajas específicas": "Protege o teu Funko com as nossas caixas específicas",
      "Añadido con tu producto": "Adicionado com o teu produto",
      /* ── Buscador y Silvia: lo que se ve en el globo ── */
      "🗂️ Explora por categoría": "🗂️ Explora por categoria",
      "Busca figuras, funko, mangas, camisetas…": "Procura figuras, funko, mangas, t-shirts…",
      "Ver todos →": "Ver todos →",
      "Ver todos los productos →": "Ver todos os produtos →",
      "Novedades": "Novidades",
      "Más vendidos": "Mais vendidos",
      "Busco yo": "Procuro eu",
      "Ayúdame ✨": "Ajuda-me ✨",
      "✨ Buscar mi regalo": "✨ Encontrar o meu presente",
      "…o elige un universo": "…ou escolhe um universo",
      "Qué tipo": "Que tipo",
      "⭐ Favorita de Alex": "⭐ Favorita de Alex",
      "¿exploras tú por todo el universo… o te ayudo a encontrar la Fuerza? ✨": "exploras tu todo o universo… ou ajudo-te a encontrar a Força? ✨",
      "🚚 Envío gratis": "🚚 Envio grátis",
      "Añadir": "Adicionar",
      "Añadido al carrito.": "Adicionado ao cesto.",
      "¿Buscas un regalo o tienes una duda?": "Procuras um presente ou tens uma dúvida?",
      "Habla con Alex, tu personal shopper friki 👋": "Fala com Alex, personal shopper friki 👋",
      "● en línea": "● online",
      "Marcas": "Marcas",
      "Precio": "Preço",
      "Ordenar": "Ordenar",
      "Relevancia": "Relevância",
      "Sin resultados": "Sem resultados",
      "En stock": "Em stock",
      "Agotado": "Esgotado",
      /* Etiquetas de las tarjetas, escritas en mayúsculas en el código */
      "NUEVO": "NOVO",
      "AGOTADO": "ESGOTADO",
      "OFERTA": "PROMOÇÃO",
      "CHOLLO": "PECHINCHA",
      /* Botones de Silvia en la portada (escritos en la plantilla del tema) */
      "🎁 Busco un regalo": "🎁 Procuro um presente",
      "🤔 Recomiéndame": "🤔 Recomenda-me",
      "✨ Novedades": "✨ Novidades",
      "💸 Menos de 20 €": "💸 Menos de 20 €",
      "🎌 Algo de anime": "🎌 Algo de anime",
      /* Dentro de la ventana del chat (clases fchat-): rótulos y sugerencias. */
      "Tu personal shopper friki": "O teu personal shopper friki",
      "Atención al cliente": "Apoio ao cliente",
      "Busco un regalo": "Procuro um presente",
      "Algo de anime": "Algo de anime",
      "Menos de 20 €": "Menos de 20 €",
      "Preguntar": "Perguntar",
      "Escribe tu mensaje…": "Escreve a tua mensagem…",
      "Escribe tu mensaje\u2026": "Escreve a tua mensagem…",
      /* El asistente se llama ALEX en todos los idiomas: el nombre ya no se
         traduce, solo las frases que lo rodean. */
      "Ej.: Ana Ejemplo": "Ex.: Ana Exemplo",
      "Empezar": "Começar",
      "Haz cualquier pregunta…": "Faz qualquer pergunta…",
      "Escríbeme lo que buscas… p. ej. “un regalo para un fan de Star Wars por menos de 20 €”": "Escreve-me o que procuras… p. ex. “um presente para um fã de Star Wars por menos de 20 €”",
      "Asistente de Frikytopia": "Assistente da Frikytopia",
      "Fuera de horario": "Fora de horário"
}
  };
  var map = DIC[lang] || (lang.indexOf('pt') === 0 ? DIC['pt-pt'] : null);
  window.FT = function (s) { return (map && map[s]) || s; };
  window.FT.lang = lang;
  window.FT.activo = !!map;
  /* FTH: traduce un bloque de HTML ya montado. FT() exige que la cadena entre
     entera y tal cual en el diccionario; cuando el HTML se compone con datos
     (puntos, códigos, importes) eso no pasa nunca, así que aquí se sustituyen
     las frases una a una, de la más larga a la más corta para que una frase
     corta no rompa dentro de otra más larga ya traducida. */
  var CLAVES = null;
  window.FTH = function (html) {
    if (!map || !html) return html;
    if (!CLAVES) CLAVES = Object.keys(map).sort(function (a, b) { return b.length - a.length; });
    var out = String(html);
    for (var i = 0; i < CLAVES.length; i++) {
      var k = CLAVES[i];
      if (out.indexOf(k) !== -1) out = out.split(k).join(map[k]);
    }
    return out;
  };

  /* COMPLEMENTOS DE PRODUCTO. El checkbox de la caja protectora lo pinta el tema
     desde el metacampo `custom.complementos`, que guarda el texto en castellano:
     en frikytopia.pt salía «Añadir caja protectora semirrígida». No pasa por FT
     —ya viene montado— así que aquí se traduce el bloque con FTH. */
  /* PASADA POR EL DOM. Nuestros widgets (buscador, Silvia, reseñas…) montan su
     HTML en el navegador y no todas las frases pasan por FT: en frikytopia.pt se
     veían mezcladas («OS MAIS VENDIDOS» junto a «NOVEDADES» o «AYÚDAME»). Aquí se
     traduce lo ya pintado, SOLO dentro de elementos nuestros (clases fkb-, friky-,
     fkr-) para no tocar nada del tema, y solo texto y textos de campo: no se
     reescribe el HTML, así que ningún botón pierde su comportamiento. */
  var NUESTRO = '[class*="fkb-"],[class*="friky-"],[class*="fkr-"],[class*="silvia-"],[class*="fh-chip"],[class*="fh-chips"],[class*="fchat"]';
  var vistos = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function traduceNodo(nodo) {
    if (vistos) { if (vistos.has(nodo)) return; vistos.add(nodo); }
    var t = nodo.nodeValue;
    if (!t || !t.trim() || t.length > 400) return;
    var directa = map[t.trim()];
    var nuevo = directa != null ? t.replace(t.trim(), directa) : window.FTH(t);
    if (nuevo !== t) nodo.nodeValue = nuevo;
  }
  function traduceRaiz(raiz) {
    if (!raiz || raiz.nodeType !== 1) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = w.nextNode())) traduceNodo(n);
    var els = raiz.querySelectorAll('[placeholder],[aria-label],[title]');
    for (var i = 0; i < els.length; i++) {
      for (var j = 0; j < 3; j++) {
        var a = ['placeholder', 'aria-label', 'title'][j], v = els[i].getAttribute(a);
        if (!v) continue;
        var nv = map[v.trim()] || window.FTH(v);
        if (nv !== v) els[i].setAttribute(a, nv);
      }
    }
  }
  function traduceWidgets() {
    var raices = document.querySelectorAll(NUESTRO);
    for (var i = 0; i < raices.length; i++) traduceRaiz(raices[i]);
  }
  if (map && typeof MutationObserver === 'function') {
    var pend = null;
    var arrancar = function () {
      traduceWidgets();
      new MutationObserver(function () {
        if (pend) return;
        pend = setTimeout(function () { pend = null; traduceWidgets(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
  }

  if (map) {
    var traduceAddons = function () {
      var ns = document.querySelectorAll('.friky-caja-addon__txt');
      for (var i = 0; i < ns.length; i++) {
        var el = ns[i];
        if (el.getAttribute('data-ft') === '1') continue;
        var antes = el.innerHTML, despues = window.FTH(antes);
        if (despues !== antes) el.innerHTML = despues;
        el.setAttribute('data-ft', '1');
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', traduceAddons);
    else traduceAddons();
    // El tema repinta la ficha al cambiar de variante y en el editor de temas.
    document.addEventListener('shopify:section:load', traduceAddons);
    setTimeout(traduceAddons, 1500);
  }
})();
